<template>
  <div class="question">
    <el-card class="box-card" style="margin-bottom: 20px; font-size: 14px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="
            $route.query.chapterId
              ? { path: '/chapter' }
              : $route.query.examId
              ? { path: '/exam' }
              : ''
          "
          >{{
            $route.query.chapterId ? "章节管理" : $route.query.examId ? "试卷管理" : ""
          }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>试题</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.chapterId && titleNmae.courseName">{{
          titleNmae.courseName
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.chapterId && titleNmae.pname">{{
          titleNmae.pname
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.chapterId && titleNmae.name">{{
          titleNmae.name
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.chapterId && titleNmae.name"
          >试题量&nbsp;:&nbsp;{{ titleNmae.questionNum }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card box-cards" v-auth="'/chapterView/search'">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <!-- <el-col v-if="!$route.query.chapterId||!$route.query.examId" :sm="24" :md="12" :lg="3">
            <el-form-item label="课程" prop="courseId">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>-->

          <el-col :sm="24" :md="12" :lg="4">
            <el-form-item label="题型" prop="questionTypeId" class="form-bottom">
              <el-select
                clearable
                v-model="searchForm.questionTypeId"
                placeholder="请输入题型"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-form-item
              style="width: 220px"
              label="题干"
              prop="title"
              class="form-bottom"
            >
              <el-input
                style="width: 150px"
                clearable
                v-model="searchForm.title"
                placeholder="请输入题干"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-form-item
              v-if="$route.query.chapterId"
              style="width: 220px"
              label="考点"
              prop="title"
              class="form-bottom"
            >
              <el-select
                multiple
                collapse-tags
                clearable
                filterable
                v-model="searchForm.knowledgeIds"
                placeholder="考点"
              >
                <el-option
                  v-for="item in knowledgeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="!$route.query.chapterId||!$route.query.examId" :sm="24" :md="12" :lg="3">
            <el-form-item prop="state" style="margin-left:-40px;">
              <el-radio-group v-model="searchForm.state">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="-1">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>-->
          <el-col style="float: right" :sm="24" :md="12" :lg="12">
            <div class="button-Array" style="float: right">
              <!-- <el-button
                type="primary"
                @click="reset"
                icon="el-icon-refresh"
              >重置</el-button>-->
              <a class="mainColor" @click="reset">清空</a>
              <el-button
                type="primary"
                style="border-top-right-radius: 0px; border-bottom-right-radius: 0px"
                @click="pageList"
                icon="el-icon-search"
                >查询</el-button
              >

              <el-button
                v-auth="'/chapterView/addCpQuestion'"
                type="success"
                style="border-radius: 0px"
                @click="goQuestion('addCpQuestion')"
                icon="el-icon-plus"
                >添加大题</el-button
              >
              <el-button
                v-auth="'/chapterView/addQuestion'"
                type="primary"
                style="
                  border-radius: 0px;
                  background: rgb(24, 200, 168);
                  border-color: rgb(24, 200, 168);
                "
                @click="goQuestion('addQuestion')"
                icon="el-icon-plus"
                >添加试题</el-button
              >
              <!-- <el-button
                type="primary"
                style="border-radius:0px;background:rgb(24,200,168);border-color:rgb(24,200,168)"
                icon="el-icon-plus"
              >-->
              <!-- <el-dropdown @command="handleCommand">
                   <el-button type="primary" style="border-radius:0px !important;margin:0 -4px;background:rgb(24,200,168);border-color:rgb(24,200,168)">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                    添加试题
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="'addCpQuestion'">添加大题</el-dropdown-item>
                    <el-dropdown-item :command="'addQuestion'">添加试题</el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>-->
              <el-button
                v-auth="'/chapterView/importForm'"
                style="border-radius: 0px"
                type="primary"
                @click="importFormVisible = true"
                >批量导入</el-button
              >
              <el-button
                v-auth="'/chapterView/batchDeleteQuestion'"
                type="danger"
                :style="
                  $route.query.examId
                    ? 'border-radius:0px;'
                    : 'border-top-left-radius:0px;border-bottom-left-radius:0px;'
                "
                @click="batchDeleteQuestion"
                icon="el-icon-delete"
                >批量解绑</el-button
              >
              <el-button
                v-auth="'/chapterView/addQuestionBatchExam'"
                type="primary"
                style="border-top-left-radius: 0px; border-bottom-left-radius: 0px"
                @click="addVideoVisible = true"
                v-if="$route.query.examId || $route.query.chapterId"
                icon="el-icon-delete"
                >绑定试题</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <!-- addFormVisible = true -->
      <el-row :span="24" v-if="$route.query.examId">
        <el-col :span="12">
          <div style="line-height: 30px; color: #333; margin-bottom: 10px">
            所属试卷：{{ examMsg.examName }}
          </div>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <div style="line-height: 30px; color: #333; margin-bottom: 10px">
            <span
              style="margin-right: 10px"
              v-for="(item, ids) in examMsg.ruleInfo"
              :key="ids"
            >
              {{ item.name }}:
              <span :style="item.nums[0] > item.nums[1] ? 'color:red' : ''">{{
                item.nums[0]
              }}</span>
              /{{ item.nums[1] }}
              <span>{{ item.name == "分值" ? "分" : "题" }}</span>
            </span>
          </div>
        </el-col>
      </el-row>

      <el-table
        ref="multipleTable"
        :data="page.rows"
        style="width: 100%; margin-top: 0px"
        row-key="id"
        @sort-change="sortChange"
        border
        v-loading="webLoading"
        element-loading-text="数据正在加载中。。。"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @selection-change="selectionChange"
      >
        >
        <el-table-column
          type="selection"
          width="40"
          v-if="$route.query.chapterId || $route.query.examId"
        ></el-table-column>
        <!-- <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="big" label="类型" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.big == 1">大题</span>
            <span v-else-if="scope.row.big == -1 && scope.row.pid.length == 1"
              >常规试题</span
            >
            <span v-else>小题</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序"
          width="70"
          align="center"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column prop="state" label="状态" align="center" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.state==1">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>-->
        <el-table-column
          prop="courseName"
          label="课程"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="questionTypeName"
          label="题型"
          align="center"
          width="80"
          show-overflow-tooltip
        ></el-table-column>-->
        <!-- <el-table-column prop="big" label="视频" align="center" width="80">
          <template slot-scope="scope">
            <i
              class="iconfont iconicon-test operItem"
              @click="goAddQusetion(scope.row.id)"
              title="添加视屏"
            ></i>
          </template>
        </el-table-column>-->
        <!-- <el-table-column prop="big" label="添加小题" align="center" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <i
              v-if="scope.row.big!=-1"
              class="iconfont iconicon-test operItem"
              @click="goAddQusetion(scope.row.id)"
              title="添加小题"
            ></i>
          </template>
        </el-table-column>-->
        <el-table-column prop="title" show-overflow-tooltip label="题干">
          <template slot-scope="scope">
            <div class="message">
              <div class="state">
                <span v-if="scope.row.state == 1" style="background: rgb(24, 200, 168)"
                  >上架</span
                >
                <span v-else style="background: rgba(231, 76, 60, 1)">下架</span>
              </div>
              <div class="questionTypeName" v-if="scope.row.big != 1">
                <span style="background: #409eff">{{ scope.row.questionTypeName }}</span>
              </div>
              <div
                class="htmltittle"
                @click="getInfoById(scope.row.id)"
                v-html="scope.row.title"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="answer"
          label="答案"
          align="center"
          width="60"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.big != 1">{{ scope.row.answer || "-" }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" align="center" width="120">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- 编辑大题 -->
              <span
                v-auth="'/chapterView/editQuestion'"
                style="width: 25%"
                v-if="scope.row.big == 1"
                @click="goAddCpQuestion(scope.row, 1)"
              >
                <i class="iconfont iconbianji mainColor" title="编辑"></i>
              </span>
              <span
                v-auth="'/chapterView/editQuestion'"
                style="width: 25%"
                v-if="scope.row.big != 1"
                @click="goAddCpQuestion(scope.row, 2)"
              >
                <i class="iconfont iconbianji mainColor" title="编辑"></i>
              </span>
              <!-- <span style="width:25%">
                <el-dropdown @command="handleCommand2">
                  <i class="iconfont iconchakan1 mainColor" title="查看"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="`getInfoById@${scope.row.id}`">查看明细</el-dropdown-item>
                    <el-dropdown-item :command="'addQuestion'">查看引用</el-dropdown-item>
                    <el-dropdown-item :command="'addQuestion'">做题记录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <span style="width:25%" @click="getInfoById(scope.row.id)">
                <i class="iconfont iconchakan1 mainColor" title="查看"></i>
              </span> -->
              <span v-auth="'/chapterView/getInfoById'" style="width: 25%" @click="getInfoById(scope.row.id)">
                <i class="iconfont iconyulan mainColor" title="预览"></i>
              </span>
              <!-- <span style="width:25%" @click="deleteQuestion(scope.row)">
                <i class="iconfont iconshanchu mainColor" title="删除"></i>
              </span>-->
              <span style="width: 25%">
                <i
                  v-if="scope.row.big != -1"
                  v-auth="'/chapterView/addQuestion'"
                  class="iconfont iconicon-test operItem"
                  @click="goAddQusetion(scope.row.id)"
                  title="添加小题"
                ></i>
              </span>

              <!-- <span @click="selection = scope.row.id, editFormVisible = true">
                <i class="iconfont iconyinyong mainColor" title="查看引用"></i>
              </span>-->
              <!-- <span @click="selection = scope.row.id, viewLog = true">做题记录</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>-->
      <el-pagination
        background
        style="margin-top: 20px; text-align: right"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </el-card>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <Import
        v-on:showDiolog="showmessahe"
        :value="$route.query.chapterId"
        :exam="$route.query.examId"
      ></Import>
    </el-dialog>
    <el-dialog title="查看明细" :visible.sync="viewDetial" width="50%" left>
      <div class="view-content" v-if="viewForm.big == 1">
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">具体课程：</span>
            <span>{{ viewForm.courseName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">试题类型：</span>
            <span>{{
              viewForm.big == 1
                ? "大题"
                : viewForm.big == -1 && viewForm.pid.length == 1
                ? "小题"
                : "试题"
            }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">是否上架：</span>
            <span>{{ viewForm.state == 1 ? "上架" : "下架" }}</span>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题题干：</span>
          <span v-html="viewForm.title" class = "question_title"></span>
        </div>
      </div>

      <div class="view-content" v-else>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">具体课程：</span>
            <span>{{ viewForm.courseName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">试题类型：</span>
            <span>{{
              viewForm.big == 1
                ? "大题"
                : viewForm.big == -1 && viewForm.pid.length == 1
                ? "小题"
                : "试题"
            }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">试题题型：</span>
            <span>{{ viewForm.questionTypeName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">是否上架：</span>
            <span>{{ viewForm.state == 1 ? "上架" : "下架" }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">难度系数：</span>
            <el-rate disabled v-model="viewForm.hard"></el-rate>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题题干：</span>
          <span v-html="viewForm.title" class = "question_title"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题选项：</span>
          <div class="optint-list">
            <div v-for="(item, index) in viewForm.optionList" :key="index">
              <div style="font-size: 14px; line-height: 30px">
                {{ item.options }}:&nbsp;&nbsp;
                <span style="display: inline" v-html="item.name"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题答案：</span>
          <span v-html="viewForm.answer"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题解析：</span>
          <span v-html="viewForm.analysis"></span>
        </div>
        <div class="view-video">
          <span style="width: 70px; white-space: nowrap">视频音频：</span>
          <span v-if="viewForm.videoPath">
            <video
              style="max-height: 400px; width: auto; margin-top: 20px"
              controls
              preload="auto"
              oncontextmenu="return false"
              :src="viewForm.videoPath"
              v-if="viewForm.videoPath ? viewForm.videoPath.indexOf('mp4') > -1 : false"
            ></video>
            <audio
              style="margin-top: 20px"
              :src="viewForm.videoPath"
              controls="controls"
              v-if="viewForm.videoPath ? viewForm.videoPath.indexOf('mp3') > -1 : false"
            ></audio>
          </span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="viewDetial = false">取 消</el-button>
        <el-button type="primary" @click="viewDetial = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="做题记录" :visible.sync="viewLog" width="50%" left>
      <div>
        <div class="top">
          <div class="top-item" v-for="(item, index) in topData" :key="index">
            <div class="item-lable">{{ item.lable }}</div>
            <div class="item-value">{{ item.value }}</div>
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="logData"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          border
          @selection-change="selectionChange"
        >
          <el-table-column prop="courseId" label="学员手机"></el-table-column>
          <el-table-column prop="questionTypeId" label="姓名"></el-table-column>
          <el-table-column prop="title" label="注册时间"></el-table-column>
          <el-table-column prop="answer" label="答案"></el-table-column>
        </el-table>
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 20px; text-align: right"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page="page.pageNumber"
          @size-change="sizeChange"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="绑定试题" :visible.sync="addVideoVisible" width="80%" left>
      <div class="view-video">
        <div class="view-item">
          <span>具体题型:&nbsp;&nbsp;&nbsp;</span>
          <el-select
            clearable
            v-model="searchForm2.questionTypeId"
            placeholder="请输入具体题型"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="view-item" style="margin-left: 20px">
          <el-input
            clearable
            v-model="searchForm2.title"
            placeholder="请输入题干"
            auto-complete="off"
          ></el-input>
        </div>
        <el-button
          size="small"
          style="margin-left: 20px"
          @click="addConcat"
          type="primary"
        >
          <!-- <i class="iconfont icondown" style="margin-top:2px;"></i> -->
          查询
        </el-button>
      </div>
      <div class="flex">
        <div style="width: 45%">
          <el-table
            ref="multipleTable"
            :data="page2.rows"
            height="452px"
            v-loading="webLoading2"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%"
            border
            @selection-change="selectionChange2"
          >
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column prop="title" show-overflow-tooltip label="题干">
              <template slot-scope="scope">
                <div class="message">
                  <div class="questionTypeName" v-if="scope.row.big != 1">
                    <span style="background: #409eff">{{
                      scope.row.questionTypeName
                    }}</span>
                  </div>
                  <div class="htmltittle" v-html="scope.row.title"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="answer"
              label="答案"
              align="center"
              width="60"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.big != 1">{{ scope.row.answer || "-" }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right"
            :total="page2.total"
            :page-size="page2.pageSize"
            :current-page="page2.pageNumber"
            @size-change="sizeChange2"
            @current-change="currentChange2"
          ></el-pagination>
        </div>
        <div style="width: 10%" class="left-right">
          <div
            @click="addExamRightEvent"
            :class="addExamLeft.length > 0 ? 'left-right-item-select' : 'left-right-item'"
          >
            ＞
          </div>
        </div>
        <div style="width: 45%">
          <el-table
            ref="multipleTable"
            :data="addExamRight"
            height="500px"
            v-loading="webLoading2"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%"
            border
          >
            <el-table-column prop="title" show-overflow-tooltip label="题干">
              <template slot-scope="scope">
                <div class="message">
                  <div class="questionTypeName" v-if="scope.row.big != 1">
                    <span style="background: #409eff">{{
                      scope.row.questionTypeName
                    }}</span>
                  </div>
                  <div class="htmltittle" v-html="scope.row.title"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="answer"
              label="答案"
              align="center"
              width="60"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.big != 1">{{ scope.row.answer || "-" }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteAddExamRight(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button type="primary" @click="addQuestionBatchExam" icon="el-icon-document"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Import from "../conmom/import";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/addCpQuestion" || from.path == "/addQuestion") {
        vm.pageList();
      }
    });
  },
  components: { Import },
  data() {
    return {
      addExamLeft: [],
      addExamRight: [],
      nameArray: [],
      webLoading: false,
      addVideoVisible: false,
      webLoading2: false,
      topData: [
        {
          lable: "近3月做题总量",
          value: "134762",
        },
        {
          lable: "近3月答对数量",
          value: "25,538",
        },
        {
          lable: "近3月答错数量",
          value: "25,538",
        },
      ],
      viewDetial: false, //查看明细
      viewLog: false, //做题记录
      logData: [], //做题记录
      viewForm: [], //查看
      addExamArr: [], //查看
      examMsg: {}, //查看
      page2: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      titleNmae: {},
      addFormVisible: false,
      editFormVisible: false,
      addFormVisible1: false,
      importFormVisible: false,
      searchForm: {
        // courseIds: [],
        title: "",
        orderBy: "asc",
        knowledgeIds: [],
        questionTypeId: "",
        // state: null
      },
      searchForm2: {
        title: "",
        questionTypeId: "",
      },
      addForm: {
        courseId: "",
        state: null,
        questionTypeId: "",
        hard: "",
        title: "",
        answer: "",
        analysis: "",
        videoPath: "",
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确",
          },
        ],
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确",
          },
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确",
          },
        ],
        hard: [
          {
            required: true,
            message: "请输入难度系数 1-5",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "难度系数 1-5格式不正确",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur",
          },
          {
            min: 1,
            max: 7000,
            message: "标题题干长度在1到7000个字",
          },
        ],
        answer: [
          {
            required: true,
            message: "请输入试题答案",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "试题答案长度在1到255个字",
          },
        ],
        analysis: [
          {
            required: true,
            message: "请输入试题解析",
            trigger: "blur",
          },
          {
            min: 1,
            max: 4000,
            message: "试题解析长度在1到4000个字",
          },
        ],
        videoPath: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "视频地址长度在1到255个字",
          },
        ],
      },
      editForm: {
        courseId: "",
        questionTypeId: "",
        state: null,
        hard: "",
        title: "",
        answer: "",
        analysis: "",
        videoPath: "",
      },
      editFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确",
          },
        ],
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确",
          },
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确",
          },
        ],
        hard: [
          {
            required: true,
            message: "请输入难度系数 1-5",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "难度系数 1-5格式不正确",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur",
          },
          {
            min: 1,
            max: 7000,
            message: "标题题干长度在1到7000个字",
          },
        ],
        answer: [
          {
            required: true,
            message: "请输入试题答案",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "试题答案长度在1到255个字",
          },
        ],
        analysis: [
          {
            required: true,
            message: "请输入试题解析",
            trigger: "blur",
          },
          {
            min: 1,
            max: 4000,
            message: "试题解析长度在1到4000个字",
          },
        ],
        videoPath: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "视频地址长度在1到255个字",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      knowledgeList: [], //科目
      subjectTreeList: [], //科目
      selectedVal_: "", //科目
      typeList: [], //试题题型
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      loading: false,
    };
  },
  methods: {
    addExamRightEvent() {
      this.addExamLeft.forEach((item) => {
        let sty = true;
        this.addExamRight.forEach((items) => {
          if (item.id == items.id) {
            sty = false;
          }
        });
        if (sty) {
          this.addExamRight.push(item);
        }
      });
    },
    deleteAddExamRight(item) {
      this.addExamRight.forEach((res, index) => {
        if (item.id == res.id) {
          this.addExamRight.splice(index, 1);
        }
      });
      this.$message.success("移除成功,请点击保存！");
    },
    pageListByChapter() {
      this.api.question
        .getQuestionListByChapter({
          chapterId: this.$route.query.chapterId,
        })
        .then((res) => {
          this.addExamRight = res.data;
        });
    },
    sortChange(column, prop, order) {
      if (column.order == "ascending") {
        this.searchForm.orderBy = "asc";
      } else if (column.order == "descending") {
        this.searchForm.orderBy = "desc";
      }
      this.pageList();
    },
    showmessahe(data) {
      this.importFormVisible = data;
      this.pageList();
    },
    handleCommand2(command) {
      let aaa = command.split("@");
      if (aaa[0] == "getInfoById") {
        this.getInfoById(aaa[1]);
      }
    },
    // 获取试题信息
    getInfoById(id) {
      this.api.question.getInfoById({ id: id }).then((result) => {
        if (result.success) {
          this.viewForm = result.data;
          this.viewDetial = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    goAddCpQuestion(row, style) {
      if (style == 1) {
        this.$router.push({
          path: "/addCpQuestion",
          query: {
            upId: row.id,
            chapterId: this.$route.query.chapterId || "",
            examId: this.$route.query.examId || "",
            chapterIds: this.$route.query.chapterId || "",
            examIds: this.$route.query.examId || "",
          },
        });
      } else {
        this.$router.push({
          path: "/addQuestion",
          query: {
            upId: row.id,
            upPid: row.pid,
            chapterId: this.$route.query.chapterId || "",
            chapterIds: this.$route.query.chapterId || "",
            examId: this.$route.query.examId || "",
            examIds: this.$route.query.examId || "",
          },
        });
      }
    },
    handleSelectionChange(val) {},
    // 添加试题
    goAddQusetion(id) {
      this.$router.push({
        path: "/addQuestion",
        query: {
          id: id,
          examIds: this.$route.query.examId || "",
          chapterIds: this.$route.query.chapterId || "",
        },
      });
    },
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });

      // 获取试题类型
      this.api.question
        .questionTypeList()
        .then((result) => {
          this.typeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectChange(val) {
      this.searchForm.courseIds = [];
      val.forEach((item) => {
        this.searchForm.courseIds.push(item[2]);
      });
      // let arr = [];
      // let nameArr = [];
      // if (val.children) {
      //   val.children.forEach((item, index) => {
      //     if (item.children) {
      //       item.children.forEach((items, indexs) => {
      //         if (items.children) {
      //           items.children.forEach((itemss, indexss) => {
      //             if (itemss.children) {
      //               itemss.children;
      //             } else {
      //               arr.push(itemss.id);
      //               nameArr.push(itemss.name);
      //             }
      //           });
      //         } else {
      //           arr.push(items.id);
      //           nameArr.push(items.name);
      //         }
      //       });
      //     } else {
      //       arr.push(item.id);
      //       nameArr.push(item.name);
      //     }
      //   });
      // } else {
      //   arr.push(val.id);
      //   nameArr.push(val.name);
      // }
      // arr.forEach(item => {
      //   let sty = true;

      //   let index = null;
      //   this.searchForm.courseIds.forEach((items, indexs) => {
      //     if (items == item) {
      //       sty = false;
      //       index = indexs;
      //     }
      //   });
      //   if (sty) {
      //     this.searchForm.courseIds.push(item);
      //   } else {
      //     this.searchForm.courseIds.splice(index, 1);
      //   }
      // });
      // nameArr.forEach(item => {
      //   let sty = true;
      //   let index = null;
      //   this.nameArray.forEach((items, indexs) => {
      //     if (items == item) {
      //       sty = false;
      //       index = indexs;
      //     }
      //   });
      //   if (sty) {
      //     this.nameArray.push(item);
      //   } else {
      //     this.nameArray.splice(index, 1);
      //   }
      // });
      // this.selectedVal_ = "";
      // this.nameArray.forEach(item => {
      //   if (this.selectedVal_) {
      //     this.selectedVal_ = this.selectedVal_ + "," + item;
      //   } else {
      //     this.selectedVal_ = item;
      //   }
      // });
      // // console.log("arr", arr);
      // console.log("this.selectedVal_", this.selectedVal_);
    },
    getExam() {
      this.api.exam
        .getExamScoreInfo({
          examId: this.$route.query.examId,
        })
        .then((result) => {
          result.data.ruleInfo.forEach((res) => {
            for (var key in res) {
              res.name = key;
              res.nums = res[key];
            }
          });
          this.examMsg = result.data;
          console.log(1111, this.examMsg);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
      this.addConcat();
    },
    currentChange2(pageNumber) {
      this.page2.pageNumber = pageNumber;
      this.addConcat();
    },
    selectionChange(val) {
      let arr = [];
      this.multipleSelection = val;
      val.map((e) => arr.push(e.id));
      this.ids = arr;
    },
    selectionChange2(val) {
      this.addExamLeft = val;
      // this.addExamArr = val;
    },
    goQuestion(command) {
      if (this.$route.query.chapterId) {
        this.$router.push({
          path: command,
          query: {
            chapterId: this.$route.query.chapterId,
            knowledgeId: this.$route.query.knowledgeId || "",
          },
        });
      } else if (this.$route.query.examId) {
        this.$router.push({
          path: command,
          query: {
            examId: this.$route.query.examId,
          },
        });
      } else {
        this.$router.push({
          path: command,
        });
      }
    },
    getQuestion() {
      this.api.question
        .getQuestion({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.webLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      let apiStyle = "";
      if (this.$route.query.examId) {
        this.getExam();
        this.searchForm.examId = this.$route.query.examId || "";
        apiStyle = "pageListByExam";
      } else {
        this.searchForm.chapterId = this.$route.query.chapterId || "";
        apiStyle = "pageListByChapter";
        this.api.chapter
          .chapterKnowledgeList({
            chapterId: this.$route.query.chapterId,
          })
          .then((result) => {
            if (result.success) {
              this.knowledgeList = result.data;
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.api.question[apiStyle](this.searchForm)
        .then((result) => {
          if (result.success) {
            this.webLoading = false;
            this.page.rows = result.data.records;
            this.page.total = result.data.total;
          } else {
            this.webLoading = false;
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      if (this.$route.query.chapterId) {
        this.api.chapter
          .getChapterInfo({ chapterId: this.$route.query.chapterId })
          .then((result) => {
            if (result.success) {
              this.titleNmae = result.data;
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    addQuestionBatchExam() {
      if (this.$route.query.examId) {
        this.api
          .addQuestionBatchExam({
            examId: this.$route.query.examId,
            questionList: this.addExamRight,
          })
          .then((result) => {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
            this.addVideoVisible = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.$route.query.chapterId) {
        this.api
          .bindQuestionBatchChapter({
            chapterId: this.$route.query.chapterId,
            questionList: this.addExamRight,
          })
          .then((result) => {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
            this.addVideoVisible = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    addConcat() {
      this.webLoading2 = true;
      this.searchForm2.pageSize = this.page2.pageSize;
      this.searchForm2.pageNumber = this.page2.pageNumber;
      this.searchForm2.sortName = this.page2.sortName;
      this.searchForm2.sortOrder = this.page2.sortOrder;
      this.api.question
        .pageList(this.searchForm2)
        .then((result) => {
          this.webLoading2 = false;
          this.page2.rows = result.data.records;
          this.page2.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addQuestion() {
      this.addForm.title = this.$refs.myQuillEditor._data.content;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.question
            .addQuestion(this.addForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestion() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.question
            .updateQuestion(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestion(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.question
            .deleteQuestion([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteQuestion() {
      this.$confirm("您确定要进行解绑操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          if (this.ids.length > 0) {
            if (this.$route.query.examId) {
              this.api.question
                .deleteExamQuestion({
                  questionIdList: this.ids,
                  examId: this.$route.query.examId,
                })
                .then((result) => {
                  if (result.success) {
                    this.$message({
                      type: "success",
                      message: result.message,
                    });
                    this.pageList();
                  } else {
                    this.$message.error(result.message);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (this.$route.query.chapterId) {
              this.api.question
                .deleteChapterQuestion({
                  questionIdList: this.ids,
                  chapterId: this.$route.query.chapterId,
                })
                .then((result) => {
                  if (result.success) {
                    this.$message({
                      type: "success",
                      message: result.message,
                    });
                    this.pageList();
                  } else {
                    this.$message.error(result.message);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          } else {
            return this.$message.warning("请选择试题！！！");
          }
        })
        .catch(() => {});
    },
    reset() {
      if (this.$route.query.chapterId || this.$route.query.examId) {
        this.$refs.searchForm.resetFields();
      } else {
        // this.$refs.tree.setCheckedKeys([]);
        this.selectedVal_ = "";
        this.searchForm.courseIds = [];
        obj.stopPropagation = () => {};
        this.$refs.searchForm.resetFields();
        let obj = {};
        try {
          this.$refs.tree.clearValue(obj);
        } catch (err) {
          this.$refs.tree.handleClear(obj);
        }
        this.page = {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: "",
        };
        this.pageList();
      }

      // try {
      //   this.$refs.selectionTree.clearValue(obj);
      // } catch (err) {
      //   this.$refs.selectionTree.handleClear(obj);
      // }
    },
    handleCommand(command) {
      if (this.$route.query.chapterId) {
        this.$router.push({
          path: command,
          query: {
            chapterId: this.$route.query.chapterId,
          },
        });
      } else if (this.$route.query.examId) {
        this.$router.push({
          path: command,
          query: {
            examId: this.$route.query.examId,
          },
        });
      } else {
        this.$router.push({
          path: command,
        });
      }
    },
    exportExcel() {
      this.loading = true;
      this.api.question
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  watch: {
    addVideoVisible(val) {
      if (!val) {
        this.addExamArr = [];
        this.page2 = {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: "",
        };
      } else {
        this.addConcat();
        this.pageListByChapter();
      }
    },
    importFormVisible(val) {
      if (!val) {
        this.pageList();
      }
    },
    viewDetial(val) {
      if (!val) {
        this.viewForm = [];
      }
      console.log("this.viewForm", this.viewForm);
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getQuestion();
      }
    },
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
    if (this.$route.query.knowledgeId) {
      this.searchForm.knowledgeIds[0] = this.$route.query.knowledgeId;
    }
  },
};
</script>
<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
}
.left-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .left-right-item {
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-size: 14px;
    color: #a2aabc;
    margin: 10px;
    cursor: pointer;
  }
  .left-right-item-select {
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 50%;
    background: rgb(64, 158, 255);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(64, 158, 255);
    font-size: 14px;
    color: #ffffff;
    margin: 10px;
    cursor: pointer;
  }
}
p {
  font-size: 14px;
}
.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    .optint-list {
      display: flex;
      flex-direction: column;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;
    p {
      display: inline;
    }
    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        display: block;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}
.message {
  display: flex;
  flex-direction: row;
  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    img {
      display: none !important;
    }
    p {
      font-size: 12px !important;
      margin: 0px !important;
      color: #606266 !important;
      white-space: nowrap !important;
      img {
        display: none !important;
      }
    }
  }
}
.top {
  width: 100%;
  display: flex;
  background: #fff;
  .top-item {
    width: 33.3%;
    margin-left: 10px;
    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }
    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}
.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.question_title /deep/ img{
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/chapterView/index.vue